<div class="relative" [style]="userDisplay.getGradientStyle()">
	<p-menubar [model]="menuItems" [breakpoint]="'1023px'">
		<ng-template #start>
			<a [routerLink]="getHomeLink()" class="cursor-pointer">
				<img ngSrc="/images/logo_round_small.png" alt="Somerville Logo" height="40" width="40" />
			</a>
		</ng-template>
		<ng-template #end>
			<div class="flex items-center gap-2">
				<p-tieredmenu #userMenu breakpoint="7680px" [model]="userMenuItems" [popup]="true"></p-tieredmenu>
				<button
					type="button"
					class="flex items-center gap-2 rounded-md border-none bg-transparent px-2 py-1 text-sm hover:bg-gray-100"
					[attr.aria-label]="userDisplay.getUserDisplayName()"
					(click)="userMenu.toggle($event)"
				>
					<p-avatar
						shape="circle"
						class="h-7! w-7! text-xs!"
						[label]="userDisplay.getUserInitial()"
						[style]="userDisplay.getAvatarStyle()"
					></p-avatar>
					<div class="flex flex-col items-start leading-tight">
						<span class="text-[1rem]! font-medium">{{ userDisplay.getUserDisplayName() }}</span>
						<span class="text-[0.7rem] font-bold tracking-wide" [style.color]="userDisplay.getAvatarColor()">{{
							userDisplay.getRoleDisplayText()
						}}</span>
					</div>
					<i class="pi pi-chevron-down ml-2 h-1! text-[0.55rem]! font-semibold! text-gray-400"></i>
				</button>
			</div>
		</ng-template>
	</p-menubar>
	<div
		class="pointer-events-none absolute inset-0 flex items-center justify-center px-12 max-[460px]:hidden min-[461px]:flex lg:hidden"
	>
		<h1 class="max-w-[min(100%,16rem)] truncate text-center text-lg font-medium tracking-tight text-neutral-700 sm:max-w-md">
			{{ title() }}
		</h1>
	</div>
</div>

<div
	class="mx-auto min-[461px]:hidden px-2 py-2 pl-4 text-center lg:block lg:text-left"
	[style]="userDisplay.getGradientStyle()"
>
	<h1 class="text-lg font-medium tracking-tight text-neutral-700 lg:text-2xl">{{ title() }}</h1>
</div>

<app-support-request-dialog [(visible)]="supportDialogVisible"></app-support-request-dialog>
